import React from 'react'
import { Link } from 'react-router-dom'

function Pura() {
    return (
        <div className='font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
           <span className="block py-1 pl-4 mt-6">Pura</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/newpura.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">Pura</h1>
           <p className="text-xl md:text-2xl font-thin max-w-sm mx-auto text-gray-500">The ultimate gelato experience.</p>
           <p className="text-xl md:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">Ice cream display counters with innovative design and technology, distinguished by the incredible visibility it provides, it has a wide display area and a set of technological innovations that guarantee a perfect conservation of your ice cream.Models for.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
     
       <p className="text-xl md:text-2xl opacity-90">Ice cream <span className='text-gray-500'><span className='text-fuchsia-950'>-18… -15 °C</span> (4L1)<span className='text-fuchsia-950'>-18… -10 °C</span>  (4G3)</span></p>
       <p className="text-xl md:text-2xl opacity-90">Toppings<span className='text-blue-400'> -1... +7 °C</span><span className='text-gray-500'> (3M2)</span> </p>
    </div>
    
    
         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl md:text-2xl text-lime-500 text-center mt-3"> R290</p>
         </div>
    
    
    
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/newdisplaycase.jpg" className="max-w-full h-auto object-contain" />
               </div>
               <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl">Everybody will see your incredible Ice Cream!</p>
        <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl  font-thin opacity-90 mt-6">
    Specialist versions for the exhibition and service of Ice cream, for 12, 18, or 24 5L pans.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Even temperature distribution and soft ventilation prevents ice cream dehydration.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Front glass without obstacles and heated glass side panels, maximum visibility without mist.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Automatic hot gas defrost.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Lift-up front glass with gas struts for easy access and cleaning of the display area.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    Internal finishing in Stainless Steel and internal components easy to remove and to clean.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
    High-brightness and energy-efficient LED lighting.
  </li>
</ul>

    </div>
             </div>

             <div className='mb-12'>
  <p className="text-3xl font-thin text-center mb-6">
    High performance and perfect visibility for
  </p>
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 place-items-center">
    <div className="flex flex-col items-center">
      <img src="/images/scoopice.jpg" className="w-full max-w-[250px] h-auto object-contain" />
      <p className="text-center mt-2">Ice Cream</p>
    </div>
    
    <div className="flex flex-col items-center">
      <img src="/images/scoopice1.jpg" className="w-full max-w-[250px] h-auto object-contain" />
      <p className="text-center mt-2">Ice Lollies</p>
    </div>

    <div className="flex flex-col items-center">
      <img src="/images/scoopice2.jpg" className="w-full max-w-[250px] h-auto object-contain" />
      <p className="text-center mt-2">Toppings</p>
    </div>
  </div>
</div>

           
         </div>
    
     </div>
    
        </div>
      )
    }
    

export default Pura